import SectionWrapper from "../../SectionWrapper"
import Feature1 from "../../../assets/images/Feature-1.svg"
import Feature2 from "../../../assets/images/Feature-2.svg"

const VisualFeatures = () => {

    const features = [
        {
            title: "Avoid unwanted subscriptions",
            desc: "Have you ever experienced the frustration of navigating a complicated process just to cancel a subscription? With a Barrenpay Card, you can bypass the need to seek permission. Simply close the virtual card, halt the payments, and proceed to cancel the subscription hassle-free.",
            img: Feature1
        },
        {
            title: "Protect your main card information",
            desc: "Cease the practice of revealing your debit and credit card numbers. Barrenpay Cards conceal your actual card information, providing you with the ability to make payments using an automatically generated, distinctive payment Visa Cards.",
            img: Feature2
        },
    ]
    return (
        <div id="features" className="features">
            <SectionWrapper>
            <div className="custom-screen text-gray-300">
                <div className="max-w-xl mx-auto text-center">
                    <h2 className="text-gray-50 text-3xl font-semibold sm:text-4xl">
                        Secure your funds and cards
                    </h2>
                    <p className="mt-3">
                        Preventing undesired recurring charges is an important aspect of managing your finances effectively.
                        Subscriptions and services that automatically renew can often lead to unexpected charges and unnecessary expenses.
                        Our Virtual Visa cards helps you prevent all these.
                    </p>
                </div>
                <div className="mt-12">
                    <ul className="space-y-8 gap-x-6 sm:flex sm:space-y-0">
                        {
                            features.map((item, idx) => (
                                <li className="flex-1 flex flex-col justify-between border border-gray-800 rounded-2xl" key={idx}
                                    style={{
                                        background: "radial-gradient(141.61% 141.61% at 29.14% -11.49%, rgba(203, 213, 225, 0.15) 0%, rgba(203, 213, 225, 0) 57.72%)"
                                    }}
                                >
                                    <div className="p-8">
                                        <h3 className="text-gray-50 text-xl font-semibold">
                                            {item.title}
                                        </h3>
                                        <p className="mt-3 sm:text-sm md:text-base">
                                            {item.desc}
                                        </p>
                                    </div>
                                    <div className="pl-8">
                                        <image
                                            src={item.img}
                                            className="w-full ml-auto"
                                            alt={item.title}
                                        />
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </SectionWrapper>
        </div>
    )
}

export default VisualFeatures